import { Profile } from '@/entities/Profile'
import { ProfileRequests } from '@/services/profile.requests'
const profileService = new ProfileRequests()

import Vue from 'vue'
import { faker } from '@faker-js/faker'
import moment from 'moment'

const state = {
  read: null,
  edited: null
}

const getters = {
  isUnsaved: state => state.edited && !!Object.keys(state.edited).length,
  getRandomProfileData: () => () => {
    var gender = faker.name.gender(true).toUpperCase()
    var name = faker.name.firstName(gender.toLowerCase())
    var lastName = faker.name.lastName(gender.toLowerCase())
    var phoneNumber = faker.phone.phoneNumber('6########')
    var dateOfBirth = moment(faker.date.past(100)).format('YYYY-MM-DD')
    var email = faker.internet.email(name, lastName)
    return {
      gender: gender,
      name: name,
      lastName: lastName,
      phoneNumber: phoneNumber,
      dateOfBirth: dateOfBirth,
      email: email
    }
  }
}

const actions = {
  get ({ state }, { id, save }) {
    return new Promise((resolve, reject) => {
      profileService.get(id).then(async (profile) => {
        if (save) {
          state.read = profile
        }
        resolve(profile)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { id }) {
    return new Promise((resolve, reject) => {
      var read = state.read || new Profile()
      if (id) { commit('setField', { field: 'id', value: id }) }
      profileService.save(read.serialize(state.edited)).then((id) => {
        commit('resetEdited')
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, profile) {
    state.read = profile
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}